var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.3996L9 0.599331C8.99965 0.489984 8.96944 0.382799 8.91262 0.289317C8.85579 0.195834 8.7745 0.119593 8.67749 0.0687991C8.58049 0.0180055 8.47144 -0.00541772 8.36209 0.00105296C8.25274 0.00752268 8.14723 0.0436402 8.05692 0.105517L0.242983 5.50567C-0.0809944 5.72948 -0.0809944 6.26829 0.242983 6.4927L8.05692 11.8929C8.14704 11.9554 8.25261 11.992 8.36214 11.9988C8.47167 12.0057 8.58098 11.9824 8.67819 11.9315C8.7754 11.8807 8.8568 11.8042 8.91353 11.7105C8.97027 11.6167 9.00017 11.5092 9 11.3996ZM1.64108 5.99949L7.79786 1.74416L7.79785 10.2548L1.64108 5.99949Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpBackArrow);
export default __webpack_public_path__ + "static/media/lp_back_arrow.3d7dde03694d9b21e6b118810ea62959.svg";
export { ForwardRef as ReactComponent };